import React from 'react';
import axios from 'axios';
import AsyncSelect from './Select/AsyncSelect';

/**
 * Ajax Return Stucture may by:

 return [
    [ 'label' => 'Label here', 'value' => 1 ]
 ]
 */

const loadOptions = url => (
    async (inputValue) => {
        // Query the API for options.
        const { data } = await axios.get(url, {
            params: {
                query: inputValue
            }
        });

        // Return the results.
        return data;
    }
);

const FormAutocomplete = ({url, ...props}) => (
    <AsyncSelect
        cacheOptions
        loadOptions={loadOptions(url)}
        {...props}
    />
);

export default FormAutocomplete;


// WEBPACK FOOTER //
// ./resources/assets/js/components/Form/FormAutocomplete.js